// src/pages/Chapeco/ChapecoPage.js
import React from 'react'
import { Link as RouterLink, useParams, Navigate } from 'react-router-dom'
import {
  Container,
  Box,
  Typography,
  Paper,
  Divider,
  Button,
  List,
  ListItem,
  ListItemIcon,
  ListItemText
} from '@mui/material'
import { Search, CheckCircleOutline } from '@mui/icons-material'
import chapecoContent from './chapecoContent'

const ChapecoPage = () => {
  const { slug } = useParams()
  const content = chapecoContent[slug]

  if (!content) {
    return <Navigate to='/' replace />
  }

  return (
    <Box sx={{ bgcolor: 'background.default', minHeight: '100vh', py: 6 }}>
      <Container maxWidth='lg'>
        {/* Titulo */}
        <Box sx={{ textAlign: 'center', mb: 5 }}>
          <Typography
            variant='h3'
            sx={{
              fontWeight: 700,
              color: 'text.primary',
              mb: 3,
              fontSize: { xs: '1.75rem', md: '2.5rem' }
            }}
          >
            {content.title}
          </Typography>

          {content.intro.map((paragraph, index) => (
            <Typography
              key={index}
              variant='body1'
              sx={{
                color: 'text.secondary',
                maxWidth: '900px',
                mx: 'auto',
                mb: 2,
                lineHeight: 1.8
              }}
            >
              {paragraph}
            </Typography>
          ))}
        </Box>

        {/* Secoes */}
        {content.sections.map((section, sectionIndex) => (
          <React.Fragment key={sectionIndex}>
            <Box sx={{ mb: 5 }}>
              <Typography
                variant='h5'
                sx={{
                  fontWeight: 700,
                  color: 'text.primary',
                  mb: 3,
                  textAlign: 'center',
                  fontSize: { xs: '1.25rem', md: '1.5rem' }
                }}
              >
                {section.heading}
              </Typography>

              <Paper
                elevation={0}
                sx={{
                  p: { xs: 3, md: 4 },
                  borderRadius: 3,
                  border: '1px solid',
                  borderColor: 'grey.200'
                }}
              >
                {section.paragraphs &&
                  section.paragraphs.map((paragraph, pIndex) => (
                    <Typography
                      key={pIndex}
                      variant='body1'
                      sx={{
                        color: 'text.secondary',
                        mb: 2,
                        lineHeight: 1.8
                      }}
                    >
                      {paragraph}
                    </Typography>
                  ))}

                {section.list && (
                  <List dense disablePadding>
                    {section.list.map((item, itemIndex) => (
                      <ListItem key={itemIndex} sx={{ py: 0.5 }}>
                        <ListItemIcon sx={{ minWidth: 36 }}>
                          <CheckCircleOutline
                            sx={{ fontSize: '1.1rem', color: 'primary.main' }}
                          />
                        </ListItemIcon>
                        <ListItemText
                          primary={item}
                          primaryTypographyProps={{
                            variant: 'body1',
                            color: 'text.secondary'
                          }}
                        />
                      </ListItem>
                    ))}
                  </List>
                )}

                {section.footer && (
                  <Typography
                    variant='body2'
                    sx={{
                      color: 'text.secondary',
                      mt: 2,
                      fontStyle: 'italic'
                    }}
                  >
                    {section.footer}
                  </Typography>
                )}
              </Paper>
            </Box>

            {sectionIndex < content.sections.length - 1 && (
              <Divider sx={{ my: 4 }} />
            )}
          </React.Fragment>
        ))}

        {/* CTA */}
        <Paper
          elevation={0}
          sx={{
            p: { xs: 4, md: 5 },
            textAlign: 'center',
            bgcolor: 'secondary.main',
            color: 'white',
            borderRadius: 3,
            mt: 5
          }}
        >
          <Typography
            variant='h4'
            sx={{
              fontWeight: 700,
              mb: 2,
              fontSize: { xs: '1.5rem', md: '2rem' }
            }}
          >
            {content.cta.text}
          </Typography>
          <Typography
            variant='body1'
            sx={{ mb: 4, opacity: 0.9, maxWidth: '700px', mx: 'auto' }}
          >
            {content.cta.subtitle}
          </Typography>
          <Button
            component={RouterLink}
            to={content.cta.link}
            variant='contained'
            size='large'
            startIcon={<Search />}
            sx={{
              bgcolor: 'primary.main',
              color: 'white',
              px: 4,
              py: 1.5,
              fontSize: '1.1rem',
              fontWeight: 600,
              '&:hover': {
                bgcolor: 'primary.dark'
              }
            }}
          >
            {content.cta.buttonText}
          </Button>
        </Paper>

        {/* Rodape da pagina */}
        <Box sx={{ textAlign: 'center', mt: 4 }}>
          <Typography variant='body2' sx={{ color: 'text.secondary' }}>
            UMARKT — um marketplace simples para anunciar e encontrar imóveis.
          </Typography>
        </Box>
      </Container>
    </Box>
  )
}

export default ChapecoPage
